import angular from 'angular';
import {HistoricalAlertsListComponent} from './list/list.controller';
import HistoricalAlertsViewController from './view/view.controller';
import HistoricalAlertsViewNewNotesController from './view/new-notes/new-note.controller';

const historicalModule = angular
  .module('app.historical-alerts', ['ui.bootstrap', 'ui.router', 'gettext'])
  .component('historicalAlertsList', HistoricalAlertsListComponent)
  /* Controllers */
  .controller('HistoricalAlertsViewController', HistoricalAlertsViewController)
  .controller('HistoricalAlertsViewNewNotesController', HistoricalAlertsViewNewNotesController);

export default historicalModule.name;
